import React, { useState, useEffect, useRef } from "react";
import { declOfNum } from "../lib/utils";
import "./TimePicker.css";

const hours_decl = ["час", "часа", "часов"];
const minutes_decl = ["минута", "минуты", "минут"];

function generateMultiplesArray(multiply, min, max) {
  const result = [];
  if (multiply <= 0 || min > max) {
    return result; // возвращаем пустой массив при некорректных параметрах
  }
  // Находим первое число, кратное multiply и >= min
  let firstMultiple = Math.ceil(min / multiply) * multiply;
  // Генерируем числа, кратные multiply, пока они не превысят max
  for (let num = firstMultiple; num <= max; num += multiply) {
    result.push(+num);
  }
  return result;
}

const TimePeriodPicker = ({
  initialTime = 0,
  onTimeSelected,
  min = 1,
  max = 6,
  multiply = 1, // кратно числу
  unit = "hour",
}) => {
  // Корректируем начальное значение, если оно вне диапазона
  const initialHour = Math.max(min, Math.min(max, initialTime));
  const [hours, setHours] = useState(initialHour);
  const [hoursArray, setHoursArray] = useState([]);
  const hoursRef = useRef(null);
  const isScrolling = useRef(false);
  const scrollTimeout = useRef(null);

  // Генерация массива часов с учетом min/max
  // const hoursArray = generateMultiplesArray(+multiply, +min, +max);
  // const hoursArray = Array.from({ length: max - min + 1 }, (_, i) => min + i);

  useEffect(() => {
    // console.log("t", generateMultiplesArray(2, 2, 24));
    setHoursArray(generateMultiplesArray(+multiply, +min, +max));
  }, []);

  // Прокрутка к выбранному часу при инициализации и изменении
  useEffect(() => {
    if (hoursRef.current) {
      // +1 потому что первый элемент - placeholder
      // const hourIndex = hours - min + 1;
      const hourIndex = hoursArray.indexOf(+hours);
      const hourElement = hoursRef.current.children[hourIndex + 1];

      if (hourElement) {
        hoursRef.current.scrollTo({
          top:
            hourElement.offsetTop -
            hoursRef.current.offsetHeight / 2 +
            hourElement.offsetHeight / 2,
          behavior: "auto",
        });
      }
    }
  }, [hours, min, hoursArray]);

  const handleHourScroll = () => {
    if (!hoursRef.current) return;

    isScrolling.current = true;
    if (scrollTimeout.current) clearTimeout(scrollTimeout.current);

    scrollTimeout.current = setTimeout(() => {
      isScrolling.current = false;
      updateSelectedHour();
    }, 150);
  };

  const updateSelectedHour = () => {
    if (!hoursRef.current || isScrolling.current) return;

    const middle = hoursRef.current.offsetHeight / 2;
    const items = hoursRef.current.children;

    for (let i = 1; i < items.length - 1; i++) {
      // Пропускаем placeholders
      const item = items[i];
      const itemMiddle =
        item.offsetTop - hoursRef.current.scrollTop + item.offsetHeight / 2;

      if (Math.abs(itemMiddle - middle) < item.offsetHeight / 2) {
        const newHour = parseInt(item.getAttribute("data-value"));
        if (!isNaN(newHour)) {
          setHours(newHour);
          hoursRef.current.scrollTo({
            top:
              item.offsetTop -
              hoursRef.current.offsetHeight / 2 +
              item.offsetHeight / 2,
            behavior: "smooth",
          });
        }
        break;
      }
    }
  };

  const handleHourClick = (e) => {
    if (e.target.dataset?.value) {
      const clickedHour = parseInt(e.target.dataset.value);
      if (!isNaN(clickedHour)) {
        setHours(clickedHour);
      }
    }
  };

  const handleConfirm = () => {
    onTimeSelected?.(hours);
  };

  // Очистка таймаута при размонтировании
  useEffect(() => {
    return () => {
      if (scrollTimeout.current) clearTimeout(scrollTimeout.current);
    };
  }, []);

  return (
    <div className="time-picker-container">
      <div className="time-picker">
        <div
          className="time-column hours-column"
          ref={hoursRef}
          onScroll={handleHourScroll}
        >
          <div className="time-item placeholder"></div>
          {hoursArray.map((hour) => (
            <div
              key={`hour-${hour}`}
              className={`time-item ${hour === hours ? "selected" : ""}`}
              data-value={hour}
              onClick={handleHourClick}
            >
              {declOfNum(
                hour.toString(),
                unit == "hour" ? hours_decl : minutes_decl,
              )}
            </div>
          ))}
          <div className="time-item placeholder"></div>
        </div>

        <div className="time-column minutes-column">
          <button
            type="button"
            className="confirm-button"
            onClick={handleConfirm}
          >
            ок
          </button>
        </div>
        <div className="time-selection-indicator"></div>
      </div>
    </div>
  );
};

export default TimePeriodPicker;
